export default __webpack_public_path__ + "static/media/chatting-people.3d26330f.png";